export default __webpack_public_path__ + "static/media/q8.058fd714.png";